module.exports = __webpack_public_path__ + "img/Cert 01.e448aeb1.png";